/**
 * Repository Implementation: Dashboard
 * Implements IDashboardRepository interface
 */

import { inject } from 'inversify';

import type { FetchDashboardModel, ReportDetailData } from '../../domain/model/DashboardModel';
import type { IDashboardRepository } from '../../domain/repository/IDashboardRepository';
import { FetchDashboardDataSource } from '../remote/datasource/FetchDashboardDataSource';
import { DashboardApiService } from '../remote/service/DashboardAPIService';

export class DashboardRepositoryImpl implements IDashboardRepository {
  @inject(DashboardApiService)
  private readonly service!: DashboardApiService;

  async fetchDashboard(): Promise<FetchDashboardModel> {
    return FetchDashboardDataSource(this.service);
  }

  async fetchReportDetail(page: number, pageSize: number): Promise<ReportDetailData> {
    const response = await this.service.fetchReportDetail(page, pageSize);
    return {
      items: response.data,
      paging: response.paging,
    };
  }
}

